import { FaGithub, FaLinkedin, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export default function Resume() {
  return (
    <section
      id="resume"
      className="py-28 bg-gray-100 dark:bg-gray-900"
    >
      <div className="max-w-6xl mx-auto px-6">
        
        <h2 className="text-3xl font-bold text-center mb-14">
          Resume
        </h2>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-10 grid md:grid-cols-3 gap-10">
          
          {/* LEFT COLUMN */}
          <div className="md:col-span-1 space-y-8">

            <div>
              <h3 className="text-2xl font-extrabold">
                Ranjit Gautam
              </h3>
              <p className="text-blue-600 font-medium mt-1">
                Frontend Developer (React / Tailwind)
              </p>
            </div>

            <div className="space-y-3 text-sm text-gray-600 dark:text-gray-300">
              <p>📍 Butwal, Rupandehi, Nepal</p>
             

<a
  href="https://is.gd/call_ranjit"
  target="_blank"
  className="flex items-center gap-2 hover:text-blue-600"
>
  <FaPhoneAlt /> Call me
</a>
             <a
  href="mailto:ranjeetgtm69@yahoo.com"
  className="flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-blue-600 transition"
>
  <FaEnvelope /> gautey@duck.com
</a>
              <a
                href="https://github.com/ranjeetgtm"
                target="_blank"
                className="flex items-center gap-2 hover:text-blue-600"
              >
                <FaGithub /> github.com/ranjeetgtm
              </a>
              <a
                href="https://linkedin.com/in/ranjeetgtm"
                target="_blank"
                className="flex items-center gap-2 hover:text-blue-600"
              >
                <FaLinkedin /> linkedin.com/in/ranjeetgtm
              </a>
            </div>

            {/* SKILLS */}
            <div>
              <h4 className="font-semibold mb-3">Technical Skills</h4>
              <div className="flex flex-wrap gap-2">
                {[
                  "HTML5",
                  "CSS3",
                  "JavaScript (ES6+)",
                  "React.js",
                  "Tailwind CSS",
                  "Git & GitHub",
                  "Responsive Design",
                ].map(skill => (
                  <span
                    key={skill}
                    className="bg-blue-100 text-blue-700 text-xs px-3 py-1 rounded-full"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            {/* SOFT SKILLS */}
            <div>
              <h4 className="font-semibold mb-3">Soft Skills</h4>
              <ul className="text-sm space-y-1 text-gray-600 dark:text-gray-300">
                <li>• Quick Learner</li>
                <li>• Problem Solving</li>
                <li>• Team Collaboration</li>
                <li>• Clear Communication</li>
              </ul>
            </div>

          </div>

          {/* RIGHT COLUMN */}
          <div className="md:col-span-2 space-y-10">

            {/* OBJECTIVE */}
            <div>
              <h4 className="text-lg font-semibold mb-2">
                Career Objective
              </h4>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Aspiring Frontend Developer with a BSc CSIT background and
                hands-on experience in building modern, responsive web
                applications using React.js and Next.js. Seeking an entry-level
                frontend role where I can contribute to real-world projects,
                improve my skills, and grow within a professional development
                team.
              </p>
            </div>

            {/* PROJECTS */}
            <div>
              <h4 className="text-lg font-semibold mb-4">
                Projects
              </h4>
              <ul className="space-y-4 text-gray-700 dark:text-gray-300">
                <li>
                  <b>Personal Portfolio Website</b>
                  <p className="text-sm">
                    Built a modern, responsive portfolio using React.js /
                    Next.js with reusable components and clean UI design.
                  </p>
                </li>

                <li>
                  <b>React Web Applications</b>
                  <p className="text-sm">
                    Developed multiple applications using React hooks,
                    component-based architecture, and API integration.
                  </p>
                </li>

                <li className="text-sm">
                  <b>Other Projects:</b> Todo App, Weather App (API),
                  E-commerce Frontend, Admin Panel, Authentication System,
                  Dashboard with Charts
                </li>
              </ul>
            </div>

            {/* EDUCATION */}
            <div>
              <h4 className="text-lg font-semibold mb-4">
                Education
              </h4>
              <ul className="space-y-3 text-gray-700 dark:text-gray-300">
                <li>
                  <b>BSc in Computer Science & Information Technology</b><br />
                  Butwal Multiple Campus, Nepal
                </li>
                <li>
                  <b>+2 Science</b><br />
                  Oxford Higher Secondary School, Nepal
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>
      <div className="text-center mt-10">
  <a
    href="/ranjeet_resume.pdf" 
    download
    className="inline-block bg-blue-600 text-white px-6 py-3 rounded-2xl shadow-lg hover:scale-105 hover:bg-blue-700 transition transform"
  >
    Download Resume
  </a>
</div>

    </section>
  );
}
